import { LOCAL_STORAGE_KEYS, safeLocalStorage } from '@/constants/storageKeys'

interface RiskState {
  level: 'EMERGENCY' | 'UNABLE' | null
  timestamp: number
  messageCountAfterRisk: number
  riskDetectionCount: number // risk 감지 횟수 추가
  consultationId?: number | undefined // 상담 ID 추가 (undefined 허용)
  showToast: boolean
}

const RISK_MESSAGE_COUNT_THRESHOLD = 3
const RISK_DETECTION_THRESHOLD = 3 // risk 감지 3번 시 자동 종료

export const getRiskState = (): RiskState | null => {
  return safeLocalStorage.getJSON<RiskState>(LOCAL_STORAGE_KEYS.RISK_STATE)
}

export const setRiskState = (state: RiskState) => {
  safeLocalStorage.setJSON(LOCAL_STORAGE_KEYS.RISK_STATE, state)
}

export const clearRiskState = () => {
  safeLocalStorage.remove(LOCAL_STORAGE_KEYS.RISK_STATE)
}

export const incrementMessageCount = () => {
  const state = getRiskState()
  if (!state) return

  state.messageCountAfterRisk += 1

  // 모든 risk 레벨에서 3번 대화 완료 시 토스트 숨김
  if (state.messageCountAfterRisk >= RISK_MESSAGE_COUNT_THRESHOLD) {
    // 5초 후 토스트 숨김
    setTimeout(() => {
      const currentState = getRiskState()
      if (currentState) {
        currentState.showToast = false
        setRiskState(currentState)
        window.dispatchEvent(new CustomEvent('riskStateChanged'))
      }
    }, 5000)
  }

  setRiskState(state)
}

export const initializeRiskState = (level: 'EMERGENCY' | 'UNABLE', consultationId?: number | undefined) => {
  // 기존 상태 가져오기 (risk 카운트 유지)
  const existingState = getRiskState()
  const currentRiskCount = existingState?.riskDetectionCount || 0

  const state: RiskState = {
    level,
    timestamp: Date.now(),
    messageCountAfterRisk: 0,
    riskDetectionCount: currentRiskCount + 1, // risk 카운트 증가
    consultationId,
    showToast: true
  }

  setRiskState(state)

  // 3번째 risk 감지 시 이벤트 발생
  if (state.riskDetectionCount >= RISK_DETECTION_THRESHOLD) {
    window.dispatchEvent(
      new CustomEvent('riskThresholdReached', {
        detail: { consultationId, count: state.riskDetectionCount }
      })
    )
  }

  window.dispatchEvent(new CustomEvent('riskStateChanged'))

  return state
}

// 상담 시작 시 risk 카운트 초기화
export const resetRiskDetectionCount = () => {
  const state = getRiskState()
  if (state) {
    state.riskDetectionCount = 0
    setRiskState(state)
  }
}

// 로그아웃 시 호출
export const onLogout = () => {
  clearRiskState()
}
